<template>
    <div class="video">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    
}
</script>
<style>
.video{
    width: 100%;
    height: 100%;
}
</style>

